import styled from 'styled-components'
import { DrawerBodyWrapper, DrawerFooterWrapper } from '@base'
import { Spacings, Text } from '@styles'

export const FormBody = styled(DrawerBodyWrapper)``

export const FormFooter = styled(DrawerFooterWrapper)`
	gap: ${Spacings.SPACING_3B};
`

export const FormSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_1B};
	margin-bottom: ${Spacings.SPACING_3B};
`

export const SectionLabel = styled.label`
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_600};
	color: ${({ theme }) => theme.palette.text.label};
`
